<template>
	<div class="bc-ps-r">
		<audio
			id="audio"
			ref="audio"
			@play="powerON"
			@pause="powerOFF"
			@timeupdate="onTimeupdate"
			@loadedmetadata="onLoadedmetadata"
			preload="metadata"
			:src="audio.PlayURL"
			style="display: none">
		</audio>

		<div class="bc-flex bc-flex-jc-c bc-flex-ai-c bc-overflow-hide audioBox">
			<div class="bc-pd-lr-8rp controlsBox bc-ps-r">
				<mt-range
					v-model="sliderTime"
					:min="0"
					:max="100"
					:step="1"
					:bar-height="4"
					:format-tooltip="formatProcessToolTip"
					@input="rangeInput"
					@change="rangeChange()"
					class="slider"
				>
					<div slot="start">
						<div class="bc-pd-r-13rp">
							<div class="playImg" :class="isPlay ? 'play' : 'pause'" @click="playerPower"></div>
						</div>

						<div class="bc-ps-a bc-pd-t-20rp bc-pd-r-12rp bc-f-14rp audioTime" style="color: #191919; white-space: nowrap;">
							<span>{{currentTime | realFormatSecond}}</span>
							<span class="bc-fl-r">{{maxTime | realFormatSecond}}</span>
						</div>
					</div>

				</mt-range>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "w-article-audio",
		props: {
			audio: {
				type: Object,
				default: {}
			}
		},
		data() {
			return {
				isPlay: false,
				currentTime: 0,
				maxTime: 60,
				sliderTime: 0,
        playAudioId:null,//当前播放音频的id
        audioList:[],//当前页面音频列表
        audioIndex:'',//当前点击的音频下标
        condition:true,//开关
			}
		},
		methods: {
			powerON() {
				this.isPlay = true;
			},
			powerOFF() {
				this.isPlay = false;
			},
			onTimeupdate(data) {
				this.currentTime = data.target.currentTime;
				this.sliderTime = parseInt(this.currentTime / this.maxTime * 100)
			},
			onLoadedmetadata(data) {
				this.maxTime = parseInt(data.target.duration);
			},
			playerPower() {
				if (!this.$refs.audio.paused && this.isPlay) {
					// 暂停
					this.$refs.audio.pause();
				} else {
					// 播放
					this.$refs.audio.play();
				}
			},
			rangeInput() {
				this.$refs.audio.pause();
				this.$refs.audio.currentTime = parseInt(this.sliderTime / 100 * this.maxTime);
			},
			// 拖动进度条
			rangeChange() {
				this.$refs.audio.play();
			},
      //获取音频列表
      playAudio(){
        this.audioList = document.getElementsByTagName('audio');
        for(let i = 0; i < this.audioList.length; i++){
          this.audioList[i].addEventListener("play",(ele)=>{
            this.audioIndex = i;  //获取当前点击的音频下标
            this.playAudioId = ele.target.parentNode.parentNode.getAttribute('data-id');
          })
        }
      },
		},
    watch:{
      //不能同时播放多个音频
      playAudioId(newVal,oldVal){
        if(oldVal !== null) {
          for (let i = 0; i < this.audioList.length; i++) {
            if(this.audioList[i].parentNode.getAttribute("data-id") != newVal) {
              this.audioList[i].pause();
              this.audioList[this.audioIndex].play();
            }
          }
        }
      },
    },
    updated(){

      if(this.condition){

        setTimeout(()=>{
          this.playAudio();
        },2000);

        this.condition = false;
      }
    },
		mounted() {
			this.$nextTick(() => {
				this.$refs.audio.load();
			});
		},
		beforeDestroy() {
			this.isPlay = false;
		},
		filters: {
			realFormatSecond(second) {
				var secondType = typeof second;
				if (secondType === 'number' || secondType === 'string') {
					second = parseInt(second);
					var hours = Math.floor(second / 3600);
					second = second - hours * 3600;
					var mimute = Math.floor(second / 60);
					second = second - mimute * 60;
					return hours + ':' + ('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2);

					// return('0' + mimute).slice(-2) + ':' + ('0' + second).slice(-2);
				} else {
					// return '0:00:00'
					return '00:00'
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.audioBox {
		box-sizing: border-box;
		/*height: rem(48);*/
		padding:rem(10) 0 rem(20) 0;
		background: #f1f3f4;
		border-radius: rem(27);
		border:1px #e9eef2 solid;
	}
	
	.playImg {
		width: rem(40);
		height: rem(40);
		background-position: center center;
		background-size: 100% 100%;
	}
	.playImg.pause {
		background-image: url($base-url + '/img/home/audio_pause.png');
	}
	.playImg.play {
		background-image: url($base-url + '/img/home/audio_play.png');
	}
	
	.controlsBox {
		flex: 1;
	}
	
	.audioTime {
		left:rem(50);
		right:0;
	}
	
	/deep/ .mt-range-content {
		margin-right: 12px;
	}
	/deep/ .mt-range-runway {
		width: 100%;
	}
	
	/deep/ .mt-range-progress {
		background: #666;
	}
	
	/deep/ .mt-range-thumb {
		background: #666;
		width: 18px;
		height: 18px;
		transform: translate(-38%, 34%) !important;
	}
</style>
